var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoAdd(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C9.88621 4.02558 7.86621 4.87664 6.37142 6.37142C4.87664 7.86621 4.02558 9.88621 4 12C4.02558 14.1138 4.87664 16.1338 6.37142 17.6286C7.86621 19.1234 9.88621 19.9744 12 20C14.1138 19.9744 16.1338 19.1234 17.6286 17.6286C19.1234 16.1338 19.9744 14.1138 20 12C19.9744 9.88621 19.1234 7.86621 17.6286 6.37142C16.1338 4.87664 14.1138 4.02558 12 4ZM16.5714 12.5714H12.5714V16.5714H11.4286V12.5714H7.42857V11.4286H11.4286V7.42857H12.5714V11.4286H16.5714V12.5714Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAdd);
export default __webpack_public_path__ + "static/media/ico_add.e7d9bf65.svg";
export { ForwardRef as ReactComponent };